export const types = {
    ASSIGN: 'ASSIGN',
    APPEND: 'APPEND',
    SEARCH: 'SEARCH',
    CONVERTXMLTOOBJECT: 'CONVERT-XML-TO-OBJECT',
    REMOVEKEYS: 'REMOVE-KEYS'
};
